import React, {FC, useCallback} from 'react';

import {UnreachableError} from '../../../../../../libs/shared/core/src/helpers/types/customErrors';
import {useAppDispatch, useAppSelector} from '../../../../../helpers/appReduxHelpers';
import {AiReview} from '../../../../../helpers/models/conversationAiHelpers';
import {AnnotationAiSuggestionModel} from '../../../../../models/api/annotationModel';
import {AnnotationTypesEnum} from '../../../../../models/api/annotationTypes';
import {aiSuggestionResolveAction} from '../../../../../store/data/comments/aiSuggestionActions';
import {makeGetConversation} from '../../../../../store/data/conversations/conversationsSelectors';
import {AiKnowledgeBaseArticlesSuggestionCommentBody} from './aiKnowledgeBaseArticlesSuggestionCommentBody';
import {AiTagSuggestionCommentBody} from './aiTagSuggestionCommentBody';

/*
 * Props.
 */

interface AiSuggestionCommentBodyProps {
  conversationId: number;
  aiSuggestion: AnnotationAiSuggestionModel;
}

/*
 * Component.
 */

export const AiSuggestionCommentBody: FC<AiSuggestionCommentBodyProps> = (props) => {
  const {conversationId, aiSuggestion} = props;

  const conversation = useAppSelector(makeGetConversation<void>(() => conversationId));

  const dispatch = useAppDispatch();
  const onAiReview = useCallback(
    (aiReview: AiReview) => {
      if (conversation) {
        dispatch(aiSuggestionResolveAction(conversation.id, aiSuggestion, aiReview));
      }
    },
    [dispatch, conversation, aiSuggestion],
  );

  const {type} = aiSuggestion;
  switch (type) {
    case AnnotationTypesEnum.AI_KNOWLEDGE_BASE_ARTICLES_SUGGESTION:
      return (
        <AiKnowledgeBaseArticlesSuggestionCommentBody
          conversation={conversation}
          aiSuggestion={aiSuggestion}
          onAiReview={onAiReview}
        />
      );

    case AnnotationTypesEnum.AI_TAG_SUGGESTION:
      return (
        <AiTagSuggestionCommentBody
          conversation={conversation}
          aiSuggestion={aiSuggestion}
          onAiReview={onAiReview}
        />
      );

    default:
      throw new UnreachableError(type);
  }
};
